import React from 'react';
import { formatLocationUtil, formatNumberUtil, getUserData, withAuthCheck } from '../../../../../Utils/localStorageUtils';
import { useParams } from 'react-router-dom';
import useAsyncAction from '../../../../../hooks/usePropertyAction';
import { addInterestedUser } from '../../../../../services/propertyService';
import useCustomNavigate from '../../../../../hooks/useCustomNavigate';

const MoreDetails = ({ propertyData }) => {

  const {goTo} = useCustomNavigate()

  const { expectedPrice, ownershipType, propertyDescription } = propertyData?.pricingAndOthers?.OwnershipPriceDetails || {}
  const { type_of_flooring } = propertyData?.pricingAndOthers?.PropertyFeatures || {}
  const { status: furnishingStatus } = propertyData?.aboutProperty?.furnishings || {}


  const formattedAddress = formatLocationUtil(propertyData?.locationDetails);


  const { propertyId } = useParams();
  const userData = getUserData();
  const { execute, loading, data } = useAsyncAction(addInterestedUser); // ✅ Use the reusable hook

  const handleInterestClick = async (e) => {
    e.preventDefault();
    await withAuthCheck(async (userData) => {
      const response = await execute(propertyId, userData._id);

      if (response.success) {
        console.log("User is interested!");
      }
    })(goTo); // ✅ Pass `navigate`
  };


  return (
    <div className="bg-white px-4 sm:px-6 py-4 rounded-lg shadow-md">
      {/* Section Title */}
      <h2 className="text-lg sm:text-[24px] font-semibold text-[#303030] mb-4 sm:mb-6">More Details</h2>

      <div className="grid  grid-cols-1 sm:grid-cols-[minmax(150px,200px),1fr] sm:gap-y-4  gap-y-3">
        {/* Price Breakup */}
        {expectedPrice && (
          <>
            <div>
              <span className="text-sm sm:text-base text-[#303030] font-normal">Price Breakup</span>
            </div>
            <div>
              <span className="text-[#303030] font-semibold  text-sm sm:text-base">
                ₹ {formatNumberUtil(expectedPrice)}
              </span>
            </div>
          </>
        )}

        {/* Address */}
        {formattedAddress && (
          <>
            <div>
              <span className="text-[#303030] font-normal text-sm sm:text-base">Address</span>
            </div>
            <div>
              <span className="text-[#303030] font-semibold text-sm sm:text-base capitalize">
                {formattedAddress}
              </span>
            </div>
          </>
        )}

        {/* Furnishing */}
        {furnishingStatus && (
          <>
            <div>
              <span className="text-[#303030] text-sm sm:text-base font-normal">Furnishing</span>
            </div>
            <div>
              <span className="text-[#303030] font-semibold text-sm sm:text-base">{furnishingStatus}</span>
            </div>
          </>
        )}

        {/* Loan Offered */}
        {false && <>
          <div>
            <span className="text-[#303030] font-normal">Loan Offered</span>
          </div>
          <div>
            <p className="text-[#303030] font-semibold text-[16px]">
              Estimated EMI: ₹20747 <span className="text-gray-500">(info)</span>
            </p>
            <a href="#" className="text-blue-600 hover:underline">Apply for Home Loan</a>
            <div className="flex items-center space-x-2 mt-2">
              <img src="https://via.placeholder.com/50" alt="Indiabulls Logo" className="h-6" />
              <img src="https://via.placeholder.com/50" alt="Bank Logo" className="h-6" />
            </div>
          </div>
        </>}

        {/* Type of Ownership */}
        {ownershipType && (
          <>
            <div>
              <span className="text-[#303030] text-sm sm:text-base font-normal">Type of Ownership</span>
            </div>
            <div>
              <span className="text-[#303030] font-semibold text-sm sm:text-base">{ownershipType}</span>
            </div>
          </>
        )}


        {/* type_of_flooring */}
        {type_of_flooring && (
          <>
            <div>
              <span className="text-[#303030] text-sm sm:text-base font-normal">Flooring</span>
            </div>
            <div>
              <span className="text-[#303030] font-semibold text-sm sm:text-base">{type_of_flooring}</span>
            </div>
          </>
        )}
      </div>

      {/* Description */}
      {propertyDescription && (
        <div className="sm:mt-6 mt-4 sm:flex sm:space-x-3">
          <p className="text-[#303030] font-semibold text-sm sm:text-base">Description:</p>
          <p className="text-[#606060] font-normal text-sm sm:text-base mt-1 sm:mt-0">{propertyDescription}</p>
        </div>
      )}

      {/* Contact Owner Button */}
      <div className="sm:mt-6 mt-4 flex justify-center sm:justify-start">
        <button 
        onClick={handleInterestClick}
        className="bg-[#2b463c] text-white font-medium px-6 py-2 rounded-full hover:bg-red-700 w-full sm:w-auto"
        disabled={loading}
        >
          {loading ? "Processing..." : data?.success ? "Already Interested" : "Contact Owner"}
        </button>
      </div>
    </div>
  );
};

export default MoreDetails;
